import createVuetifyInstance from './plugins/vuetify';
import globalComponentRegistration from './plugins/globalComponents';
import DialogPromise from "./plugins/promiseDialog";
import { useFormMixin } from './mixins/useFormMixin';
import { accessible_modal_mixin } from './mixins/accessible_modal_mixin';
import { aiGenerationMixin } from './mixins/aiGenerationMixin';

function initCgltUI(Vue, { store, icons }) {
	const primary_color_key = store?.state?.site_config?.primary_color 
		? 'primary_color' 
		: (store?.state?.site_config?.vue_primary_color 
			? 'vue_primary_color' 
			: null)
	
	const secondary_color_key = store?.state?.site_config?.secondary_color
		? 'secondary_color' 
		: (store?.state?.site_config?.vue_secondary_color 
			? 'vue_secondary_color' 
			: null)
	
	const initialPrimaryColor = store?.state?.site_config?.[primary_color_key] || undefined
	const initialSecondaryColor = store?.state?.site_config?.[secondary_color_key] || undefined

	const vuetify = createVuetifyInstance({
		primaryColor: initialPrimaryColor,
		secondaryColor: initialSecondaryColor,
		icons: icons || {}
	});
    
	Vue.use(globalComponentRegistration);
	Vue.use(DialogPromise, { vuetifyInstance: vuetify });

	if (store?.watch) {
		store.watch(s => s?.site_config?.primary_color, (newColor) => {
			if (!newColor) return;
			vuetify.framework.theme.themes.light.primary = newColor;
		})
	}

	return { vuetify };
}

export { initCgltUI, useFormMixin, accessible_modal_mixin, aiGenerationMixin };
